import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * The layout for the legacy `/journeys/integrations/sql-sync/:type` URLs. Each child is a handoff:
 * the embedded Ember host while the flag is off, a forward to the migrated URL once it is on.
 */
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type')({
  component: Outlet,
});
